import { createSelector } from 'reselect';
import getPath from 'lodash/get';
import orderBy from 'lodash/orderBy';

export const ratingListSelector = createSelector(
  [
    state => getPath(state, `ratings.byId`, {}),
    (state, soundcastId) => getPath(state, `ratings.bySoundcast.${soundcastId}`, []),
  ],
  (ratingsById, ratings) => {
    const result = ratings.map(ratingId => ratingsById[ratingId]);
    return orderBy(result, ({ ratingId }) => Number(ratingId), 'desc');
  }
);
